import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

export default function Header() {
  useEffect(() => {
    // Initialize meanmenu for mobile navigation
    if (window.jQuery && $.fn.meanmenu) {
      if ($('.navigation-header').length > 0) {
        $('.navigation-header').meanmenu({
          meanScreenWidth: '1199'
        });
      }

      // Cleanup on unmount
      return () => {
        if ($('.mean-container').length > 0) {
          $('.mean-container').remove();
        }
      };
    }

     var ResponsiveMenu = {
    trigger: '#responsive-menu-button',
    animationSpeed: 500,
    breakpoint: 1024,
    pushButton: 'off',
    animationType: 'slide',
    animationSide: 'left',
    pageWrapper: '',
    isOpen: false,
    triggerTypes: 'click',
    activeClass: 'is-active',
    container: '#responsive-menu-container',
    openClass: 'responsive-menu-open',
    accordion: 'off',
    activeArrow: '▲',
    inactiveArrow: '▼',
    wrapper: '#responsive-menu-wrapper',
    closeOnBodyClick: 'off',
    closeOnLinkClick: 'off',
    itemTriggerSubMenu: 'off',
    linkElement: '.responsive-menu-item-link',
    openMenu: function() {
        $(this.trigger).addClass(this.activeClass);
        $('html').addClass(this.openClass);
        $('.responsive-menu-button-icon-active').hide();
        $('.responsive-menu-button-icon-inactive').show();
        this.setButtonTextOpen();
        this.setWrapperTranslate();
        this.isOpen = true;
    },
    closeMenu: function() {
        $(this.trigger).removeClass(this.activeClass);
        $('html').removeClass(this.openClass);
        $('.responsive-menu-button-icon-inactive').hide();
        $('.responsive-menu-button-icon-active').show();
        this.setButtonText();
        this.clearWrapperTranslate();
        this.isOpen = false;
    },
    setButtonText: function() {
        if($('.responsive-menu-button-text-open').length > 0 && $('.responsive-menu-button-text').length > 0) {
            $('.responsive-menu-button-text-open').hide();
            $('.responsive-menu-button-text').show();
        }
    },
    setButtonTextOpen: function() {
        if($('.responsive-menu-button-text').length > 0 && $('.responsive-menu-button-text-open').length > 0) {
            $('.responsive-menu-button-text').hide();
            $('.responsive-menu-button-text-open').show();
        }
    },
    triggerMenu: function() {
        this.isOpen ? this.closeMenu() : this.openMenu();
    },
    triggerSubArrow: function(subarrow) {
        var sub_menu = $(subarrow).parent().siblings('.responsive-menu-submenu');
        var self = this;
        if(this.accordion == 'on') {
            /* Get Top Most Parent and the siblings */
            var top_siblings = sub_menu.parents('.responsive-menu-item-has-children').last().siblings('.responsive-menu-item-has-children');
            var first_siblings = sub_menu.parents('.responsive-menu-item-has-children').first().siblings('.responsive-menu-item-has-children');
            /* Close up just the top level parents to key the rest as it was */
            top_siblings.children('.responsive-menu-submenu').slideUp(200, 'linear').removeClass('responsive-menu-submenu-open');
            /* Set each parent arrow to inactive */
            top_siblings.each(function() {
                $(this).find('.responsive-menu-subarrow').first().html(self.inactiveArrow);
                $(this).find('.responsive-menu-subarrow').first().removeClass('responsive-menu-subarrow-active');
            });
            /* Now Repeat for the current item siblings */
            first_siblings.children('.responsive-menu-submenu').slideUp(200, 'linear').removeClass('responsive-menu-submenu-open');
            first_siblings.each(function() {
                $(this).find('.responsive-menu-subarrow').first().html(self.inactiveArrow);
                $(this).find('.responsive-menu-subarrow').first().removeClass('responsive-menu-subarrow-active');
            });
        }
        if(sub_menu.hasClass('responsive-menu-submenu-open')) {
            sub_menu.slideUp(200, 'linear').removeClass('responsive-menu-submenu-open');
            $(subarrow).html(this.inactiveArrow);
            $(subarrow).removeClass('responsive-menu-subarrow-active');
        } else {
            sub_menu.slideDown(200, 'linear').addClass('responsive-menu-submenu-open');
            $(subarrow).html(this.activeArrow);
            $(subarrow).addClass('responsive-menu-subarrow-active');
        }
    },
    menuHeight: function() {
        return $(this.container).height();
    },
    menuWidth: function() {
        return $(this.container).width();
    },
    wrapperHeight: function() {
        return $(this.wrapper).height();
    },
    setWrapperTranslate: function() {
      var translate = '';
        switch(this.animationSide) {
            case 'left':
                translate = 'translateX(' + this.menuWidth() + 'px)'; break;
            case 'right':
                translate = 'translateX(-' + this.menuWidth() + 'px)'; break;
            case 'top':
                translate = 'translateY(' + this.wrapperHeight() + 'px)'; break;
            case 'bottom':
                translate = 'translateY(-' + this.menuHeight() + 'px)'; break;
        }
        if(this.animationType == 'push') {
            $(this.pageWrapper).css({'transform':translate});
            $('html, body').css('overflow-x', 'hidden');
        }
        if(this.pushButton == 'on') {
            $('#responsive-menu-button').css({'transform':translate});
        }
    },
    clearWrapperTranslate: function() {
        var self = this;
        if(this.animationType == 'push') {
            $(this.pageWrapper).css({'transform':''});
            setTimeout(function() {
                $('html, body').css('overflow-x', '');
            }, self.animationSpeed);
        }
        if(this.pushButton == 'on') {
            $('#responsive-menu-button').css({'transform':''});
        }
    },
    init: function() {
        var self = this;
        $(this.trigger).on(this.triggerTypes, function(e){
            e.stopPropagation();
            self.triggerMenu();
        });
        $(this.trigger).mouseup(function(){
            $(self.trigger).blur();
        });
        $('.responsive-menu-subarrow').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            self.triggerSubArrow(this);
        });
        $(window).resize(function() {
            if($(window).width() > self.breakpoint) {
                if(self.isOpen){
                    self.closeMenu();
                }
            } else {
                if($('.responsive-menu-open').length>0){
                    self.setWrapperTranslate();
                }
            }
        });
        if(this.closeOnLinkClick == 'on') {
            $(this.linkElement).on('click', function(e) {
                e.preventDefault();
                /* Fix for when close menu on parent clicks is on */
                if(self.itemTriggerSubMenu == 'on' && $(this).is('.responsive-menu-item-has-children > ' + self.linkElement)) {
                    return;
                }
                old_href = $(this).attr('href');
                old_target = typeof $(this).attr('target') == 'undefined' ? '_self' : $(this).attr('target');
                if(self.isOpen) {
                    if($(e.target).closest('.responsive-menu-subarrow').length) {
                        return;
                    }
                    self.closeMenu();
                    setTimeout(function() {
                        window.open(old_href, old_target);
                    }, self.animationSpeed);
                }
            });
        }
        if(this.closeOnBodyClick == 'on') {
            $(document).on('click', 'body', function(e) {
                if(self.isOpen) {
                    if($(e.target).closest('#responsive-menu-container').length || $(e.target).closest('#responsive-menu-button').length) {
                        return;
                    }
                }
                self.closeMenu();
            });
        }
        if(this.itemTriggerSubMenu == 'on') {
            $('.responsive-menu-item-has-children > ' + this.linkElement).on('click', function(e) {
                e.preventDefault();
                self.triggerSubArrow($(this).children('.responsive-menu-subarrow').first());
            });
        }
    }
  };

    ResponsiveMenu.init();
  }, []);

  return (
    <header className="header">
      <div className="row no-gutters">
        <div className="col-10 col-sm-6 col-xl-4 col-custom-3">
          <div className="logo">
            <Link to="/">
              <img src="/images/logo-ovatures.png" alt="Ovatures" width="auto" height="64" />
            </Link>
          </div>
        </div>
        <div className="col-lg-5 col-xl-6 col-custom-5 d-none d-custom2-block">
          <div className="navigation-header">
            <ul id="menu-header" className="clearfix">
              <li><a href="https://www.ovatures.com/who-are-we">Who are we?</a></li>
              <li><a href="https://www.ovatures.com/why-donate">Why donate?</a></li>
              <li><a href="https://www.ovatures.com/the-process">The process</a></li>
              <li><a href="https://www.ovatures.com/about-us/">About Us</a></li>
              <li><a href="https://www.ovatures.com/faqs">FAQs</a></li>
              <li><a href="https://www.ovatures.com/blog">Blog</a></li>
            </ul>
          </div>
        </div>
        <div className="col-sm-4 col-xl-2 col-custom-4 d-custom-right text-left sm-text-center d-none d-sm-inline">
          <div className="contact clearfix">
            <span className="text">Questions?</span>
            <span className="phone">
              <a
                href="tel:973-656-2876"
                onClick={() => {
                  // Google Analytics tracking (if GA is available)
                  if (window.ga) {
                    window.ga('send', 'event', 'Phone Call', 'Click', 'Phone Number');
                  }
                }}
              >
                <span className="d-none d-custom-block">973-656-2876</span>
              </a>
            </span>
            <span className="link">
              <a href="https://www.ovatures.com/contact-us" className="btn-appointment">
                <span className="d-none d-custom-block">Book an appointment</span>
              </a>
            </span>
          </div>
        </div>
        <div className="col-2 d-xl-none">
          <button id="responsive-menu-button" className="responsive-menu-button responsive-menu-boring responsive-menu-accessible" type="button" aria-label="Menu">
              <span className="responsive-menu-box">
                  <span className="responsive-menu-inner"></span>
              </span>
          </button>
          <div id="responsive-menu-container" className="slide-left">
              <div id="responsive-menu-wrapper">
                  <ul id="responsive-menu" className="">
                    <li id="responsive-menu-item-1391" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item"><a href="https://www.ovatures.com/who-are-we/" className="responsive-menu-item-link">Who are we?</a></li>
                    <li id="responsive-menu-item-1603" className=" menu-item menu-item-type-custom menu-item-object-custom responsive-menu-item"><a href="https://www.ovatures.com/why-donate/" className="responsive-menu-item-link">Why donate?</a></li>
                    <li id="responsive-menu-item-1393" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item"><a href="https://www.ovatures.com/the-process/" className="responsive-menu-item-link">The process</a></li>
                    <li id="responsive-menu-item-2029" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item"><a href="https://www.ovatures.com/about-us/" className="responsive-menu-item-link">About Us</a></li>
                    <li id="responsive-menu-item-1540" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item"><a href="https://www.ovatures.com/faqs/" className="responsive-menu-item-link">FAQs</a></li>
                    <li id="responsive-menu-item-1395" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item"><a href="https://www.ovatures.com/blog/" className="responsive-menu-item-link">Blog</a></li>
                    <li id="responsive-menu-item-1397" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item d-sm-none"><a href="tel:973-656-2876" className="responsive-menu-item-link icon-phone">973-656-2876</a></li>
                    <li id="responsive-menu-item-1396" className=" menu-item menu-item-type-post_type menu-item-object-page responsive-menu-item d-sm-none"><a href="https://www.ovatures.com/contact-us/" className="responsive-menu-item-link icon-email">Book an appointment</a></li>
                  </ul>                                                                
                </div>
          </div>
        </div>
      </div>
    </header>
  );
}
